import { useSelector } from 'react-redux'
import { Logo } from 'src/Components'
import Header from 'src/Components/shared/Header'
import { YourHomeDropdown } from './YourHomeDropdown'
import { FindAHomeDropdown } from './FindAHomeDropdown'
import { DesktopAuthButtons } from './DesktopAuthButtons'
import { selectIsSoloRea } from 'src/store/selectors/customerProfile'
import AgentDropdown from 'src/App/Layout/Header/AgentDropdown'
import styles from './DesktopHeader.module.scss'

export const DesktopHeader = ({ enableAgentDropdown, ...restProps }) => {
  const isSoloRea = useSelector(selectIsSoloRea)

  return (
    <Header className={styles.header} {...restProps}>
      <Header.Content>
        <Logo className={styles.logo} />
        <div className={styles.navigation}>
          <div className={styles.tab}>
            <YourHomeDropdown />
          </div>
          {!isSoloRea && (
            <div className={styles.tab}>
              <FindAHomeDropdown />
            </div>
          )}
        </div>
        <div className={styles.desktopActions}>
          <DesktopAuthButtons />
          {enableAgentDropdown && <AgentDropdown />}
        </div>
      </Header.Content>
    </Header>
  )
}
